import { render, staticRenderFns } from "./CreateDOTSVisitDate.vue?vue&type=template&id=e38c6134&scoped=true"
import script from "./CreateDOTSVisitDate.vue?vue&type=script&lang=js"
export * from "./CreateDOTSVisitDate.vue?vue&type=script&lang=js"
import style0 from "./CreateDOTSVisitDate.vue?vue&type=style&index=0&id=e38c6134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38c6134",
  null
  
)

export default component.exports